'use client';

import { inferFailedToolCallLabel } from '@terra/shared-dto-chat-types';
import { useTranslations } from 'next-intl';
import {
  getHeadlineCopy,
  type ChatHeadlineCopy,
  type ChatHeadlineKind,
} from './chat-headline-actions';

export function useHeadlineCopy(kind: ChatHeadlineKind): ChatHeadlineCopy {
  const t = useTranslations('designSystem.chat');

  if (kind === 'use-skill') {
    const running = t('usingSkill');

    return {
      running,
      done: t('usedSkill'),
      failed: inferFailedToolCallLabel(running),
    };
  }

  if (kind === 'explore') {
    const running = t('exploring');

    return {
      running,
      done: t('explored'),
      failed: inferFailedToolCallLabel(running),
    };
  }

  if (kind === 'passthrough') {
    const running = t('working');

    return {
      running,
      done: t('done'),
      failed: inferFailedToolCallLabel(running),
    };
  }

  return getHeadlineCopy(kind);
}
